import React, { useState, useEffect } from "react";
import { Icon } from "@mui/material";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Grid } from '@mui/material';
import { cutNotes, convertWhiteColor } from 'Core/data/Helpers';
import cx from 'classnames';
import { useIntl } from 'react-intl';

import { Tooltip } from 'Components'

import { Checkbox as NewCheckbox } from '@gpstrackit/gtc-react-controls';

import './style.scss'

const Header = (props) => {
    return (
        <span className={'headerClass'} {...props}>
            {props.children}
        </span>
    )
}

const TagTitle = (props) => {

    if (!props.props) return (<div></div>);

    const { props: propsGroup } = props;
    let path = propsGroup?.path;
    if (propsGroup.path == '') path = '/';

    if (path) {
        const nombreTitle = propsGroup?.path ? `/${propsGroup?.path}/${props.children}` : `${path}${props.children}`
        return (
            <Tooltip title={nombreTitle}>
                <span className={'titleClass'} {...props}>
                    {cutNotes(props.children, 33)}
                </span>
            </Tooltip>
        )
    }
    if (props.children?.length > 33) {
        return (
            <Tooltip title={props?.children}>
                <span className={'titleClass'} {...props}>
                    {cutNotes(props?.children, 33)}
                </span>
            </Tooltip>
        )
    }
    return (
        <span className={'titleClass'} {...props}>
            {props.children}
        </span>
    )
}

const Title = (props) => {
    const className = !props?.noclassname ? 'titleClass' : ''
    if (props.children?.length > 33) {
        return (
            <Tooltip title={props?.children}>
                <span className={className} {...props}>
                    {cutNotes(props?.children, 33)}
                </span>
            </Tooltip>
        )
    }
    return (
        <span className={className} {...props}>
            {props.children}
        </span>
    )
}

const ItemLabelValue = (props) => {
    const { messageTooltip, highlight } = props
    if (props.children?.length > 33 && !messageTooltip) {
        return (
            <Tooltip title={props?.children}>
                <span style={{ fontWeight: 500 }}>
                    {cutNotes(props?.children, 33)}
                </span>
            </Tooltip>
        )
    }
    return (
        <span style={ !messageTooltip || highlight ? { fontWeight: 500 } : {}}>
            {props.children}
        </span>
    )
}

const TitleContainer = (props) => {
    return (
        <div className={'titleContainerClass'} {...props}>
            {props.children}
        </div>
    )
}

const ItemListContainer = (props) => {
    return (
        <div className={'itemListContainerClass'}  {...props}>
            {props.children}
        </div>
    )
}

const ItemLabel = (props) => {
    let arrayProps = { ...props }
    let className = props.highlight ? 'circle-sketch-highlight itemLabelClass' : 'itemLabelClass'
    className = props.noClickEvent ? `${className} itemNoItemClick` : className
    delete arrayProps['noClickEvent']
    delete arrayProps['highlight']
    delete arrayProps['noClickEventMessage']
    delete arrayProps['highlightMessage']

    if (props?.noClickEvent || props?.highlight) {
        const messageTooltip = props?.highlight == 1 ? props?.highlightMessage : props?.noClickEventMessage || 'No click event'
        return (
            <div
                className={cx('', className ? className : "")}
            >
                <Tooltip title={messageTooltip}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {
                            props.highlight == 1
                            &&
                            <div>
                                <VisibilityIcon style={{ fontSize: 22, color: 'black' }} />
                            </div>
                        }
                        <div style={props.highlight == 1 ? { paddingLeft: 10 } : { paddingLeft: 0 }}>
                            <div className={className} {...arrayProps}>
                                <ItemLabelValue highlight={props?.highlight} messageTooltip={messageTooltip} >
                                    {props.children} 
                                </ItemLabelValue>
                            </div>
                        </div>
                    </div>
                </Tooltip>
            </div>
        )
    } else {
        return (
            <div
                {...arrayProps}
                className={cx('', className ? className : "")}
            >
                {
                    arrayProps?.icon
                    &&
                    <img style={{ width: 20, height: 20 }} src={arrayProps?.icon} className="groupItem-icon" />
                }
                    <ItemLabelValue highlight={props?.highlight}>
                        {props.children} 
                    </ItemLabelValue>
            </div>
        )
    }

}

const LocalOffer = (props) => {
    const { color, visible, onClick } = props;
    const convertColor = convertWhiteColor(color); //conver color to gray
    const styleElement = { fontSize: 18, color: convertColor };
    const className = !color ? 'defaultColorItem' : '';
    return (
        <div onClick={onClick}>
            {visible && <LocalOfferIcon style={color ? styleElement : {}} className={className} />}
            {!visible && <LocalOfferOutlinedIcon style={color ? styleElement : {}} className={className} />}
        </div>
    );
}

const GroupItem = (props) => {
    const { messages } = useIntl();
    const {
        defaultExpanded,
        restart,
        expanded: newExpanded,
        id,
        visible,
        color,
        name,
        items,
        filter,
        messageNoItems,
        open,
        loading,
        expandedAll,
        renderItemActions,
        onMouseEnter,
        onMouseLeave,
        displayCheckOnItems
    } = props;

    const [expanded, setExpanded] = useState(true);
    const [arrayLoadElements, setArrayLoadElements] = useState([]);

    useEffect(() => {
        if (defaultExpanded) {
            setExpanded(true);
        }
    }, [defaultExpanded]);

    useEffect(() => {
        if (restart) {
            setExpanded(true);
            setArrayLoadElements([]);
        }
    }, [restart]);

    useEffect(() => {
        if (newExpanded) {
            setExpanded(true);
        } else {
            setExpanded(false);
        }
    }, [newExpanded]);

    const onGroupCheckChanged = () => {
        if (props.onGroupCheckChanged) props.onGroupCheckChanged(id, !visible);
    }

    const onItemClicked = (item) => {
        if (props.onItemClicked) props.onItemClicked(item);
    }

    const onTitleContainerClicked = () => {
        setExpanded(!expanded);
        const arrayIds = [...arrayLoadElements];

        //Validate previus loading elements
        const find = arrayIds.find((item) => item == id);
        if (!find && props.onTitleContainerClicked) {
            arrayIds.push(id);
            setArrayLoadElements([...arrayIds]);
            props.onTitleContainerClicked(id, !expanded);
        } else {
            if (props.onExpanded) props.onExpanded(id, !expanded);
        }
    }

    const hasItems = (items && items.length > 0) || !items;
    //const filtered = filter && filter.length > 0 ? items.filter(({ name }) => name.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) : items;
    const filtered = items;

    //const ShowGroup = hasItems ? visible : false ;
    let openExpanded = expanded || expandedAll;
    if (!hasItems) openExpanded = false;

    return (
        <div>
            {
                <Header>
                    {
                        openExpanded
                            ?
                            <Icon
                                className='groupList-icon'
                                onClick={() => onTitleContainerClicked()}
                            >
                                arrow_drop_down
                            </Icon>
                            :
                            <Icon
                                className='groupList-icon'
                                onClick={() => onTitleContainerClicked()}
                            >
                                arrow_right
                            </Icon>
                    }

                    <Tooltip
                        title={!visible ? `${messages['show']} ${name}` : `${messages['hide']} ${name}`}
                        placement="right"
                    >
                        <div style={{display: 'flex', alignItems: 'center'}}>
                        {
                            displayCheckOnItems
                            &&
                            <NewCheckbox 
                                key={`key_${id}`} 
                                id={id} 
                                //label={label} 
                                value={visible}
                                checked={visible}
                                onChange={onGroupCheckChanged} 
                            />
                        }
                            <LocalOffer
                                visible={visible}
                                color={color}
                                onClick={onGroupCheckChanged}
                            />
                        </div>
                    </Tooltip>

                    <TitleContainer onClick={() => onTitleContainerClicked(id)}>
                        <TagTitle props={props}>{name}</TagTitle>
                    </TitleContainer>
                </Header>
            }

            {
                (!expanded && !filter && !hasItems && !loading)
                &&
                <ItemLabel>{messageNoItems}</ItemLabel>
            }

            {
                hasItems && (openExpanded || (filter && hasItems)) &&
                <ItemListContainer>
                    {filtered.map((item, index) => {
                        return (
                            <div
                                key={`${item.id}-${item.name}-${index}`}
                                className={cx(props.highlightId != item.id ? 'group-item-hover gtc-container direction-row justify-content-space-between align-items-center context-menu-container' : "")}
                                onMouseEnter={(e) => {
                                    if (onMouseEnter) onMouseEnter(item);
                                }}
                                onMouseLeave={(e) => {
                                    if (onMouseLeave) onMouseLeave(item);
                                }}
                            >
                                <div
                                    className={`gtc-item ${renderItemActions ? "ellipsis-text" : ""}`}
                                    style={{
                                        maxWidth: renderItemActions ? "80%" : ""
                                    }}
                                >
                                    <ItemLabel
                                        noClickEvent={item.noClickEvent}
                                        highlight={props.highlightId == item.id ? 1 : 0}
                                        noClickEventMessage={props.noClickEventMessage}
                                        highlightMessage={props.highlightMessage}
                                        icon={item?.icon}
                                        className="ellipsis-text"
                                        onClick={() => {
                                            if (!item.noClickEvent) {
                                                onItemClicked(item, id)
                                            }
                                        }}
                                    >
                                        {item?.name}
                                    </ItemLabel>
                                </div>

                                <div className="gtc-item">
                                    {renderItemActions && renderItemActions(item)}
                                </div>
                            </div>
                        )
                    })}
                </ItemListContainer>
            }
        </div>
    )
}

export default React.memo(GroupItem);